export default "__VITE_ASSET__CM8S6gOb__"